import React, { useEffect, useMemo, useState } from "react";
import _ from "lodash";
import { Button, FormLayout, Heading, Input, Select } from "@/ui";
import { useForm, useValidator } from "@/hooks";
import {
    EVENT_TYPE_LISTTRACK,
    SUBSCRIPTION_SOURCE_TYPE,
} from "../../config/constant";
import styles from "./SwifterForm.module.scss";

const fieldError = (validator, name) =>
    validator?.[name]?.isInvalid ? validator[name].message : undefined;

const ListTrackAddItem = ({
    app,
    handleCancel,
    handlerUpdatingOrCreate,
    isCreate,
    isUpdating,
    state,
    setState,
}) => {
    const [isFormReset, resetFormInputs] = useState(isCreate);
    const { inputs, inputChange, setInputs } = useForm();

    const { validator, isValid, isSubmited } = useValidator(
        [
            {
                field: "id",
                method: "isEmpty",
                validWhen: false,
                message: "This Id is required.",
            },
            {
                field: "name",
                method: "isEmpty",
                validWhen: false,
                message: "This Name is required.",
            },
        ],
        {
            ...inputs,
        },
    );

    const {
        validator: validatorSources,
        isValid: isValidSources,
        isSubmited: isSubmitedSources,
    } = useValidator(
        [
            {
                field: "id",
                method: "isEmpty",
                validWhen: false,
                message: "This Id is required.",
            },
            {
                field: "event_id",
                method: "isEmpty",
                validWhen: false,
                message: "This Event Id is required.",
            },
            {
                field: "type",
                method: "isEmpty",
                validWhen: false,
                message: "This Type is required.",
            },
        ],
        {
            ...inputs,
        },
    );

    const {
        validator: validatorMessages,
        isValid: isValidMessages,
        isSubmited: isSubmitedMessages,
    } = useValidator(
        [
            {
                field: "message_id",
                method: "isEmpty",
                validWhen: false,
                message: "This Message Id is required.",
            },
            {
                field: "event_type",
                method: "isEmpty",
                validWhen: false,
                message: "This Event Type is required.",
            },
        ],
        {
            ...inputs,
        },
    );

    if (!isCreate && !isFormReset) {
        resetFormInputs(true);
    }

    useEffect(() => {
        if (isCreate) {
            resetForm();
        }
        if (!isCreate) {
            let itemUpdate = null;
            if (state.form === "Order Field") {
                itemUpdate = app.order_fields[state.selected];
            }

            if (state.form === "Password Field") {
                itemUpdate = app.password_fields[state.selected];
            }

            if (state.form === "Store Field") {
                itemUpdate = app.store_fields[state.selected];
            }

            if (state.form === "Message") {
                itemUpdate = app.messages[state.selected];
            }

            if (state.form === "Subscribe Lists") {
                itemUpdate = app.subscribe_lists[state.selected];
            }

            if (state.form === "Subscribe Fields") {
                itemUpdate = app.subscribe_fields[state.selected];
            }

            if (state.form === "Sources") {
                itemUpdate = app.sources[state.selected];
            }

            setInputs(itemUpdate);
        }
    }, [state.form, state.selected]);

    const createOrUpdate = () => {
        if (isSubmitedMessages) {
            isSubmitedMessages(true);
        }

        if (isSubmitedSources) {
            isSubmitedSources(true);
        }

        if (isSubmited) {
            isSubmited(true);
        }

        if (isValidMessages() || isValid() || isValidSources()) {
            let newList = [];

            if (state.form === "Order Field") {
                newList = _.cloneDeep(app.order_fields || []);
            }

            if (state.form === "Password Field") {
                newList = _.cloneDeep(app.password_fields || []);
            }

            if (state.form === "Store Field") {
                newList = _.cloneDeep(app.store_fields || []);
            }

            if (state.form === "Message") {
                newList = _.cloneDeep(app.messages || []);
            }

            if (state.form === "Subscribe Lists") {
                newList = _.cloneDeep(app.subscribe_lists || []);
            }

            if (state.form === "Subscribe Fields") {
                newList = _.cloneDeep(app.subscribe_fields || []);
            }

            if (state.form === "Sources") {
                newList = _.cloneDeep(app.sources || []);
            }

            if (isCreate) {
                if (state.form === "Message") {
                    newList.push({
                        message_id: inputs.message_id,
                        event_type: inputs.event_type,
                        __typename: "ListTrackMessage",
                    });
                }
                if (state.form === "Sources") {
                    newList.push({
                        id: parseInt(inputs.id),
                        type: inputs.type,
                        event_id: inputs.event_id,
                        __typename: "ListTrackSourceFields",
                    });
                }
                if (state.form !== "Message" && state.form !== "Sources") {
                    newList.push({
                        id: parseInt(inputs.id),
                        name: inputs.name,
                        __typename: "ListTrackField",
                    });
                }
            } else {
                if (state.form === "Message") {
                    newList[state.selected] = {
                        ...inputs,
                        message_id: inputs.message_id,
                        event_type: inputs.event_type,
                    };
                }
                if (state.form === "Sources") {
                    newList[state.selected] = {
                        ...inputs,
                        id: parseInt(inputs.id),
                        type: inputs.type,
                        event_id: inputs.event_id,
                    };
                }
                if (state.form !== "Message" && state.form !== "Sources") {
                    newList[state.selected] = {
                        ...inputs,
                        id: parseInt(inputs.id),
                        name: inputs.name,
                    };
                }
            }

            setState({ ...state, updateList: newList });
            handlerUpdatingOrCreate(newList);
        }
    };

    const handleClose = () => {
        handleCancel();
        resetFormInputs(false);
    };

    const resetForm = () => {
        setInputs({
            id: null,
            name: "",
            message_id: "",
            event_type: "",
            event_id: "",
            type: "",
        });
        resetFormInputs(false);
    };

    const sourceTypeOptions = useMemo(
        () =>
            (SUBSCRIPTION_SOURCE_TYPE || []).map(option => ({
                value: String(option.value),
                label: option.label,
            })),
        [],
    );

    const eventTypeOptions = useMemo(
        () =>
            (EVENT_TYPE_LISTTRACK || []).map(option => ({
                value: String(option.value),
                label: option.label,
            })),
        [],
    );

    const handleSourceTypeChange = value => {
        const option = (SUBSCRIPTION_SOURCE_TYPE || []).find(
            item => String(item.value) === value,
        );
        setInputs({
            ...inputs,
            type: option ? option.value : value,
        });
    };

    const handleEventTypeChange = value => {
        const option = (EVENT_TYPE_LISTTRACK || []).find(
            item => String(item.value) === value,
        );
        setInputs({
            ...inputs,
            event_type: option ? option.value : value,
        });
    };

    return (
        <div className={styles.credentialForm}>
            <Heading level={5}>
                {isCreate ? "Add " : "Update "}
                {`${state.form}`}
            </Heading>

            <FormLayout>
                <FormLayout.Section>
                    {state.form === "Sources" ? (
                        <FormLayout.Grid columns={2} maxWidth="twoThirds">
                            <Input
                                error={fieldError(validatorSources, "id")}
                                fullWidth
                                label="Id"
                                name="id"
                                onChange={inputChange}
                                placeholder="Id"
                                value={inputs.id ?? ""}
                            />
                            <Select
                                error={fieldError(validatorSources, "type")}
                                fullWidth
                                label="Type"
                                onValueChange={handleSourceTypeChange}
                                options={sourceTypeOptions}
                                placeholder="type"
                                value={
                                    inputs.type != null && inputs.type !== ""
                                        ? String(inputs.type)
                                        : undefined
                                }
                            />
                            <Input
                                error={fieldError(validatorSources, "event_id")}
                                fullWidth
                                label="Event Id"
                                name="event_id"
                                onChange={inputChange}
                                placeholder="Event_Id"
                                value={inputs.event_id || ""}
                            />
                        </FormLayout.Grid>
                    ) : null}

                    {state.form === "Message" ? (
                        <FormLayout.Grid columns={2} maxWidth="twoThirds">
                            <Input
                                error={fieldError(
                                    validatorMessages,
                                    "message_id",
                                )}
                                fullWidth
                                label="Message Id"
                                name="message_id"
                                onChange={inputChange}
                                placeholder="Message Id"
                                value={inputs.message_id || ""}
                            />
                            <Select
                                error={fieldError(
                                    validatorMessages,
                                    "event_type",
                                )}
                                fullWidth
                                label="Event type"
                                onValueChange={handleEventTypeChange}
                                options={eventTypeOptions}
                                placeholder="Event type"
                                value={
                                    inputs.event_type != null &&
                                    inputs.event_type !== ""
                                        ? String(inputs.event_type)
                                        : undefined
                                }
                            />
                        </FormLayout.Grid>
                    ) : null}

                    {state.form !== "Message" && state.form !== "Sources" ? (
                        <FormLayout.Grid columns={2} maxWidth="twoThirds">
                            <Input
                                error={fieldError(validator, "id")}
                                fullWidth
                                label="Id"
                                name="id"
                                onChange={inputChange}
                                placeholder="Id"
                                type="number"
                                value={inputs.id ?? ""}
                            />
                            <Input
                                error={fieldError(validator, "name")}
                                fullWidth
                                label="Name"
                                name="name"
                                onChange={inputChange}
                                placeholder="Name"
                                type="text"
                                value={inputs.name || ""}
                            />
                        </FormLayout.Grid>
                    ) : null}
                </FormLayout.Section>
            </FormLayout>

            <div className={styles.credentialActions}>
                <Button
                    disabled={isUpdating}
                    onClick={handleClose}
                    type="button"
                    variant="secondary"
                >
                    Cancel
                </Button>
                <Button
                    loading={isUpdating}
                    onClick={createOrUpdate}
                    type="button"
                >
                    Save
                </Button>
            </div>
        </div>
    );
};

export default ListTrackAddItem;
